

type SpacingProps = {
  height?: string;
  width?: string;
};

export const Spacing: React.FC<SpacingProps> = ({ height, width }) => {
  // shrink-0: a spacer must keep its size. Inside a bounded overflow-y-auto flex
  // column (e.g. the event list/table pages) flexbox would otherwise shrink an
  // empty spacer to 0, collapsing the intended gap. No-op outside flex; grow
  // spacers using flex-1 still grow.
  return <div className={`${height} ${width} shrink-0 `} />;
};
